export interface Points {
  x: string;
  y: string;
}

interface ContextMenuProps {
  containerRef?: HTMLElement | null;
  contextmenuRef: HTMLElement | null;
}

const useContextMenu = (props: ContextMenuProps) => {
  const { containerRef, contextmenuRef } = props;
  const [visible, setVisible] = useState(false);
  const [points, setPoints] = useState({ x: '-100%', y: '-100%' });

  const onContextMenu = useCallback(
    (e: React.MouseEvent<HTMLElement> | MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      const mouseX = e.clientX;
      const mouseY = e.clientY;
      const cWidth = window.innerWidth;
      const cHeight = window.innerHeight;

      const { height: mHeight, width: mWidth } =
        contextmenuRef!.getBoundingClientRect();
      let menuLeft = mouseX;
      let menuTop = mouseY;

      if (mouseX + mWidth > cWidth) {
        menuLeft = mouseX - mWidth;
      }

      if (mouseY + mHeight > cHeight) {
        menuTop = mouseY - mHeight;
      }

      setPoints({ x: menuLeft + 'px', y: menuTop + 'px' });
      setVisible(true);
    },
    [contextmenuRef]
  );

  useEffect(() => {
    containerRef?.addEventListener('contextmenu', onContextMenu);
    return () => {
      containerRef?.removeEventListener('contextmenu', onContextMenu);
    };
  }, [containerRef, onContextMenu]);

  useEffect(() => {
    const handleClick = () => {
      setVisible(false);
    };

    document.addEventListener('click', handleClick, true);
    document.addEventListener('contextmenu', handleClick, true);
    return () => {
      document.removeEventListener('click', handleClick, true);
      document.removeEventListener('contextmenu', handleClick, true);
    };
  }, []);

  return { visible, setVisible, points, setPoints, onContextMenu };
};

export default useContextMenu;
